import { render, staticRenderFns } from "./TargetSituation.vue?vue&type=template&id=47c76804"
import script from "./TargetSituation.vue?vue&type=script&lang=js"
export * from "./TargetSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports